// InvoiceTemplateItem Component
/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import DateUtil from '../../../lib/dateutil.jsx'
import currency from '../../../lib/currency.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'

class InvoiceTemplateItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      bShowItems: false
    }
  }

  static get propTypes () {
    return {
      invoiceTemplate: PropTypes.object,
      teamPaymentPeriod: PropTypes.number,
      showProjectNumber: PropTypes.bool,
      onView: PropTypes.func,
      onSetting: PropTypes.func,
      onSubView: PropTypes.func,
      isQuickbookConnected: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      invoiceTemplate: null,
      teamPaymentPeriod: 0,
      showProjectNumber: false,
      onView: null,
      onSetting: null,
      onSubView: null,
      isQuickbookConnected: false
    }
  }

  render () {
    const invoiceTemplate = this.props.invoiceTemplate
    const date = new Date(invoiceTemplate.nextRecurringDate)

    let noItems = 0
    if (invoiceTemplate.items && invoiceTemplate.items.length > 0) {
      noItems = invoiceTemplate.items.length
    }
    const completed = !!(
      invoiceTemplate.noTotal &&
      invoiceTemplate.noFinalized === invoiceTemplate.noTotal
    )

    const _className = classnames('invoicetemplate-item', {
      expanded: this.state.bShowItems,
      'invoicetemplate-item_draft': !invoiceTemplate.isActive,
      'invoicetemplate-item_completed': completed,
      'invoicetemplate-item_cancelled': invoiceTemplate.isCanceled
    })

    const paymentDays =
      invoiceTemplate &&
      invoiceTemplate.contact &&
      invoiceTemplate.contact.paymentDays &&
      invoiceTemplate.contact.paymentDays !== -1
        ? invoiceTemplate.contact.paymentDays
        : this.props.teamPaymentPeriod

    let bShowSetting = false
    // If active but not complated/cancelled, user can open settings and stop
    if (
      invoiceTemplate.isActive &&
      !invoiceTemplate.isCompleted &&
      !invoiceTemplate.isCanceled
    ) {
      bShowSetting = true

      // If not active and not complated/cancelled, user can open settings and stop
    } else if (
      !invoiceTemplate.isActive &&
      !invoiceTemplate.isCompleted &&
      !invoiceTemplate.isCanceled
    ) {
      bShowSetting = true
    }

    const showProjectNumber = this.props.showProjectNumber
    const isQuickbookConnected = this.props.isQuickbookConnected

    return (
      <div className={_className} onClick={this._onView.bind(this)}>
        {completed ? (
          <div className='colsuccess'>
            <i className='icon icon-list-itemcompleted normal' />
          </div>
        ) : invoiceTemplate.isCanceled ? (
          <div className='colsuccess'>
            <i className='icon icon-list-warning normal' />
          </div>
        ) : (
          <div className='coldate'>
            <div className='month'>{DateUtil.getDisplayMonth(date)}</div>
            <div className='day'>{DateUtil.getDisplayDay(date)}</div>
            <div className='year'>{DateUtil.getDisplayYear(date)}</div>
          </div>
        )}
        <div className='colsplit' />
        <div className='colinner'>
          <h4 className='title'>
            {invoiceTemplate.project
              ? (showProjectNumber
                  ? `${invoiceTemplate.project.projectNumber || '-'} / `
                  : '') + `${invoiceTemplate.project.title}`
              : '-'}
          </h4>
          <div className='info'>
            <div className='value'>
              <span className='interval'>
                <i className='icon icon-list-iteminterval normal' />
              </span>
              {IntlUtil.convertMessage(
                `invoicetemplate.view.headerLabel${invoiceTemplate.interval}`
              )}
            </div>
            <div className='split' />
            <div className='value'>
              {!completed ? (
                <IntlMessage ident='invoicetemplate.item.paymentterm' />
              ) : (
                <IntlMessage ident='invoicetemplate.item.paymenttermdays' />
              )}
              &nbsp;
              {!completed ? paymentDays : ''}
              {!completed ? (
                <IntlMessage ident='invoicetemplate.item.paymenttermdays' />
              ) : (
                ''
              )}
            </div>
            <div className='split' />
            <div className='value'>
              <IntlMessage ident='invoicetemplate.item.until' />
              &nbsp;
              {DateUtil.getDisplayDate(invoiceTemplate.lastRecurringDate)}
            </div>
            <div className='split' />
            <div className='value send'>
              <span className='completed'>{invoiceTemplate.noFinalized}</span>/
              <span className='total'>{invoiceTemplate.noTotal}</span>
              <IntlMessage ident='invoicetemplate.item.send' />
            </div>
            <div className='split' />
            <div className='value'>
              {invoiceTemplate.contact ? invoiceTemplate.contact.company : ''}
            </div>
          </div>
        </div>
        <div className='colsplit' />
        <div className='coltotal'>
          <div className={`amount${isQuickbookConnected ? ' hideincl' : ''}`}>
            <h2 className='total'>
              <span className='price'>
                <PriceText value={invoiceTemplate.total} />
              </span>
            </h2>
            {!isQuickbookConnected && (
              <div className='vatvalue'>
                <IntlMessage ident='invoicetemplate.item.vatIncText' />
                &nbsp;
                <PriceText value={invoiceTemplate.totalInc} />
              </div>
            )}
          </div>
          {noItems > 0 && (
            <div className='expandact' onClick={this._onClickExpand.bind(this)}>
              <span className='iconcont'>
                <i className='icon icon-grid-expand normal' />
                <i className='icon icon-grid-expand-hover hover' />
              </span>
            </div>
          )}
        </div>
        {this.state.bShowItems && noItems > 0 && (
          <div className='subitems'>
            {this._renderSubItems(invoiceTemplate)}
          </div>
        )}
        {bShowSetting && (
          <IconButton
            title='invoicetemplate.item.titleSettings'
            icon='common-action-setting'
            size='small'
            onClick={this._onSetting.bind(this)}
          />
        )}
      </div>
    )
  }

  /* Event handlers */
  _onView (e) {
    e.preventDefault()

    if (this.props.onView) {
      this.props.onView(this.props.invoiceTemplate)
    }
  }

  _onSetting (e) {
    e.preventDefault()
    e.stopPropagation()

    if (this.props.onSetting) {
      this.props.onSetting(this.props.invoiceTemplate)
    }
  }

  _onClickExpand (e) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({ bShowItems: !this.state.bShowItems })
  }

  _onClickSubItem (item, e) {
    e.preventDefault()
    e.stopPropagation()

    if (this.props.onSubView) {
      this.props.onSubView(item.id)
    }
  }

  /* Private Functions */
  _renderSubItems (invoiceTemplate) {
    return invoiceTemplate.items.map((item, idx) => {
      return this._renderTemplateSubItem(item, idx)
    })
  }

  _renderTemplateSubItem (item, idx) {
    const typeClass = item.status.toLowerCase()
    const _className = classnames('subitem', {}, `subitem_${typeClass}`)
    let statusText = `${IntlUtil.convertMessage(
      'invoicetemplate.item.draftText'
    )}`

    if (typeClass !== 'draft') {
      statusText = `${IntlUtil.convertMessage(
        'invoicetemplate.item.invoiceNoPrefix'
      )}
        ${item.invoiceNo}`
    }

    return (
      <div
        className={_className}
        key={idx}
        onClick={this._onClickSubItem.bind(this, item)}
      >
        <div className='itemcol date'>
          {DateUtil.getDisplayDate(item.invoiceDate)}
        </div>
        <div className='itemcol number'>{statusText}</div>
        <div className='itemcol status'>{item.status}</div>
        <div className='itemcol total'>{currency.format(item.total)}</div>
      </div>
    )
  }
}

export default InvoiceTemplateItem
